/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLightbulbIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-lightbulb"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22.7Q12 22.7 11.53 22.7Q11.05 22.7 10.43 22.07Q9.8 21.45 9.85 20.5L14.15 20.5Q14.2 21.45 13.57 22.07Q12.95 22.7 12 22.7ZM8.93 19.95Q8.38 19.95 7.99 19.56Q7.6 19.18 7.6 18.63Q7.6 18.07 7.99 17.69Q8.38 17.3 8.93 17.3L15.07 17.3Q15.63 17.3 16.01 17.69Q16.4 18.07 16.4 18.63Q16.4 19.18 16.01 19.56Q15.63 19.95 15.07 19.95ZM8 16.75Q6.05 15.65 4.9 13.71Q3.75 11.78 3.75 9.5Q3.75 6.08 6.16 3.66Q8.57 1.25 12 1.25Q15.43 1.25 17.84 3.66Q20.25 6.08 20.25 9.5Q20.25 11.78 19.1 13.71Q17.95 15.65 16 16.75Z" fill={color} />
    </svg>
  );
}
